.bold-label {
    font-size: var(--font-normal);
    line-height: 21px;
    font-weight: 500;
    color: var(--grey);
}
